<template>
  <div class="incenters">
    <div>
      <!-- v-if="qx.add"  -->
      <Commonbtn backgroundColor="#FFF" title="新增" fontSize="14px" :src="require('@/assets/icon/icon-add.png')" @btnclick="adduser">
      </Commonbtn>
      <!-- v-if="qx.update" -->
      <Commonbtn :useAutoOptional="false" backgroundColor="#FFF" title="修改" fontSize="14px" :src="require('@/assets/icon/icon-update.png')" @btnclick="update">
      </Commonbtn>
      <!--  v-if="qx.del" -->
      <Commonbtn backgroundColor="#FFF" title="删除" fontSize="14px" :src="require('@/assets/icon/icon-del.png')" @btnclick="del">
      </Commonbtn>

    </div>
    <!-- style="border: 1px solid blue;" -->
    <div class="TableWidth">
      <Commontable @onRowClick="onRowClick" colnum=7 :tableData="tableData" :headerData="headerData" height="100%">
      </Commontable>
      <div class="pagination">
        <Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total"></Pagination>
      </div>
    </div>
    <DialogFrom width="680px" title="新增用户" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK">
      <div class="from">
        <template v-for="(item , index) of fromdataadd">
          <Commondropdownlist :key="index" ref="add" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width" :min="item.min" :max="item.max"></Commondropdownlist>
        </template>
      </div>
    </DialogFrom>
    <DialogFrom width="680px" title="修改用户" :dialogVisible="dialogVisiblesedit" @cancel="canceledit" @dialogOK="dialogOKedit">
      <div class="from">
        <template v-for="(item , index) of fromdataedit">
          <Commondropdownlist :key="index" ref="update" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width" :min="item.min" :max="item.max"></Commondropdownlist>
        </template>
      </div>
    </DialogFrom>
    <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel" :src="require('@/assets/icon/icon-del2.png')">
      <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除该权限吗？</span>
    </Dialog>
  </div>
</template>
<script>
import Commondropdownlist from '../../../components/common-dropdownlist.vue'
import Commontable from '../../../components/common-table.vue'
import Commonbtn from '../../../components/common-btn.vue'
import Pagination from '../../../components/pagination.vue'
import DialogFrom from '../../../components/dialog-from.vue'
import fromdata from '../fromData/add'
import fromdataedit from '../fromData/edit'
import Dialog from '../../../components/dialog.vue'
import {
  AuthorityLists,
  AuthorityListInfo,
  AuthorityListsAdd,
  Authoritydeit,
  Authoritydel
} from '@/api/home.js'
export default {
  components: {
    Commontable,
    Commonbtn,
    Pagination,
    DialogFrom,
    Commondropdownlist,
    Dialog
  },
  props: {
    tableData: {
      type: Array,
      default: Array
    },
    total: {
      type: Number,
      default: 0
    },
  },
  data: function () {
    return {
      dialogVisibles: false,
      dialogVisiblesedit: false,
      dialogVisibledel: false,
      dialogVisiblestop: false,
      dialogVisiblessigningroles: false,
      dialogVisiblesassignproductline: false,
      dialogVisiblesasimportproductline: false,
      dialogVisiblesasjxsimportdealer: false,
      dialogVisiblechpassword: false,
      rightboo: false,
      dwonleft: false,
      auid: null,
      ptype: '',
      fromdataadd: [],
      fromdataedit: [],
      qx: {
        add: false,
        update: false,
        del: false,
        stopif: true,
        daoc: true,
        assignment: false,
        enabled: false
      },
      qus: [],
      headerData: [{
        prop: 'AUID',
        label: '序号',
        columnwidth: 50
      },
      {
        prop: 'AuthorityName',
        label: '权限名称',
        columnwidth: 220
      },
      {
        prop: 'AuthorityCode',
        label: '权限编码',
        columnwidth: 200
      },
      {
        prop: 'Remark',
        label: '描述',
        columnwidth: 428
      },
      {
        prop: 'SortNum',
        label: '排序列',
        columnwidth: 463
      }
      ],
      headerData1: [{
        prop: 'id',
        label: '序号',
        columnwidth: 50
      },
      {
        prop: 'zuz',
        label: '组织代码',
        columnwidth: 120
      },
      {
        prop: 'zuzname',
        label: '所属组织名称',
        columnwidth: 300
      },
      ],
      tableData1: [{
        id: '1',
        zuz: '445',
        zuzname: '北京中兴昊然医疗技术有限公司',
      },
      {
        id: '1',
        zuz: 'ZX558888',
        zuzname: '北京中兴昊然医疗技术有限公司',
      },
      {
        id: '1',
        zuz: 'ZX558888',
        zuzname: '北京中兴昊然医疗技术有限公司',
      },
      ],
    }
  },
  created() {

  },
  mounted() {
    this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
    this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
    // this.QX()
  },
  methods: {
    QX() {
      let data = JSON.parse(localStorage.getItem("MenusData"))
        data.Menus.map((item, index) => {
        if (item.NodeID == 1) {
          item.Nodes.map((items, indexs) => {
            if (items.NodeID == 4) {
              this.qus = items.Nodes
            }
          })
        }
      })
      if (this.qus) {
        this.qus.map((item, index) => {
          if (item.NodeName == 'add') {
            this.qx.add = true
          } else if (item.NodeName == 'edit') {
            this.qx.update = true
          } else if (item.NodeName == 'delete') {
            this.qx.del = true
          } else if (item.NodeName == 'stopif') {
            this.qx.del = true
          } else if (item.NodeName == 'assignment') {
            this.qx.assignment = true
          } else if (item.NodeName == 'enabled') {
            this.qx.enabled = true
          }
        })
      }
    },
    //查询详情
    async authorityListdetails() {
      let boxslistdetails = await AuthorityListInfo({
        auid: this.auid
      })
      if (boxslistdetails.code == 0) {
        // this.tableData = boxslist.data.data
      }
      //console.log('boxslistdetails', boxslistdetails)
    },
    //新增
    async authorityListsAdd(datas) {
      let boxslistdetails = await AuthorityListsAdd({
        auid: 10,
        authorityCode: datas[1].modelvalue,
        authorityName: datas[0].modelvalue,
        remark: datas[2].modelvalue,
        sortNum: datas[3].modelvalue
      })
      if (boxslistdetails.code == 0) {
        this.$message({
          type: 'success',
          message: '新增成功'
        });
        this.$parent.authorityLists();
        return
      }
      this.$message({
        type: 'error',
        message: boxslistdetails.message
      });
      // 清除新增文本框
      this.$refs.add.map((item, index) => {
        item.modelvalue = ''
      })
      //console.log('boxslistdetails', boxslistdetails)
    },
    //修改
    async authorityListedit(datalist) {
      let boxslistedit = await Authoritydeit({
        auid: this.auid,
        authorityCode: datalist[1].modelvalue,
        authorityName: datalist[0].modelvalue,
        remark: datalist[2].modelvalue,
        sortNum: datalist[3].modelvalue
      })
      if (boxslistedit.code == 0) {

        this.$message({
          type: 'success',
          message: '修改成功！'
        });
        this.$parent.authorityLists();
        return
      }
      this.$message({
        type: 'error',
        message: boxslistedit.message
      });
      //console.log('boxslistedit', boxslistedit)
    },
    // 删除
    async authoritydel() {
      let boxslistdel = await Authoritydel({
        auid: this.auid
      })
      if (boxslistdel.code == 0) {

        this.$message({
          type: 'success',
          message: '删除成功！'
        });
        this.$parent.authorityLists();
        return
      }
      this.$message({
        type: 'error',
        message: boxslistdel.message
      });
    },
    handleCurrentChange(pageindex) {
      this.$emit('handleCurrentChange', pageindex)

    },
    handleSizeChange(paegSzie) {
      this.$emit('handleSizeChange', paegSzie)

    },
    // 选中行
    onRowClick(val) {
      //console.log("行", val)
      fromdataedit[0].inputdata = val.AuthorityName
      fromdataedit[1].inputdata = val.AuthorityCode
      fromdataedit[2].inputdata = val.Remark
      fromdataedit[3].inputdata = val.SortNum
      this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
      this.auid = val.AUID
      this.rowboo = true
    },
    commclick(type) {
      this[type] = true
    },
    // commcancelclick(type){
    // 	this[type] = false
    // },
    // commdialogOKclick(type){
    // 	this[type] = false
    // },
    adduser() {
      this.dialogVisibles = true
      //console.log(this.fromdataadd, '//console.log(this.fromdataadd)')
    },
    cancel() {
      this.dialogVisibles = false
    },
    dialogOK() {
      //console.log(this.$refs.add)
      this.authorityListsAdd(this.$refs.add)
      this.dialogVisibles = false
    },
    update() {
      if (this.rowboo) {
        this.dialogVisiblesedit = true
        this.authorityListdetails()
        return
      }
      this.$message({
        type: 'error',
        message: '请选择要修改的数据！'
      });

    },
    canceledit() {
      this.dialogVisiblesedit = false
    },
    dialogOKedit() {
      this.authorityListedit(this.$refs.update)
      this.dialogVisiblesedit = false
    },
    del() {
      if (this.rowboo) {
        this.dialogVisibledel = true
        return
      }
      this.$message({
        type: 'error',
        message: '请选择要删除的数据！'
      });
    },
    canceldel() {
      this.dialogVisibledel = false
    },
    dialogOKdel() {
      this.authoritydel()
      this.dialogVisibledel = false
    },
    stop() {
      this.dialogVisiblestop = true
    },
    cancelstop() {
      this.dialogVisiblestop = false
    },
    dialogOKstop() {
      this.dialogVisiblestop = false
    },
    assigningroles() {
      this.dialogVisiblessigningroles = true
    },
    cancelsigningroles() {
      this.dialogVisiblessigningroles = false
    },
    dialogOKsigningroles() {
      this.dialogVisiblessigningroles = false
    },
    assignproductline() {
      this.dialogVisiblesassignproductline = true
    },
    canceldialogVisiblesassignproductline() {
      this.dialogVisiblesassignproductline = false
    },
    dialogOKdialogVisiblesassignproductline() {
      this.dialogVisiblesassignproductline = false
    },
    canceldialogVisiblesasimportproductline() {
      this.dialogVisiblesasimportproductline = false
    },
    dialogOKdialogVisiblesasimportproductline() {
      this.dialogVisiblesasimportproductline = false
    },
    importdealerbtn() {
      this.dialogVisiblesasjxsimportdealer = true
    },
    canceldialogVisiblesasjxsimportdealer() {
      this.dialogVisiblesasjxsimportdealer = false
    },
    dialogOKdialogVisiblesjxsasimportdealer() {
      this.dialogVisiblesasjxsimportdealer = false
    },
    czpassword() {
      this.dialogVisiblechpassword = true
    },
    cancelpassword() {
      this.dialogVisiblechpassword = false
    },
    dialogOKpassword() {
      this.dialogVisiblechpassword = false
    },
    dwonlist() {
      this.dwonleft = !this.dwonleft
    },
    downclick() {
      this.dwonleft = false
      this.dialogVisiblesasimportproductline = true
    }
  },

}
</script>

<style lang="less" scoped>
.incenters {
  height: 100%;

  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  // div {
  //   margin-left: 8px;
  //   margin-right: 8px;
  //   margin-top: 5px;
  //   margin-bottom: 5px;

  // }
  .from {
    width: 100%;
  }

  .signingroles {
    height: 500px;
    width: 100%;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    // border: 1px solid red;

    .left {
      height: 240px;
      width: 470px;
      border: 1px solid #e6e6e6;
    }

    .right {
      height: 240px;
      width: 470px;
      border: 1px solid #e6e6e6;
      // pointer-events: none;
    }
  }
}
.right-s {
  position: absolute;
  z-index: 99;
  opacity: 0.5;
  right: 21px;
  width: 470px;
  height: 240px;
  background-color: #ffffff;
  cursor: no-drop;
}
.dwonleft {
  width: 170px;
  height: 48px;
  position: absolute;
  background-color: #ffffff;
  z-index: 99;
  right: 350px;
  top: 322px;
  text-align: center;
  line-height: 48px;
  color: #333333;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
    0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  font-size: 14px;
  cursor: pointer;
}
.dwonleft:hover {
  background-color: #f0f0f0;
}
</style>
